import React from "react";
import "./StudentAvatar.scss";

export const getAvatarColor = (first: string, last: string) => {
  const name = `${first}${last}`;
  let hashCode = 0;

  for (let i = 0; i < name.length; i++) {
    hashCode = name.charCodeAt(i) + ((hashCode << 5) - hashCode);
  }

  const h = Math.abs(hashCode) % 360;
  const s = 60 + (Math.abs(hashCode >> 8) % 30);
  const l = 35 + (Math.abs(hashCode >> 16) % 30);

  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const StudentAvatar = ({ firstName, lastName }: { firstName: string; lastName: string }) => {
  const color = getAvatarColor(firstName, lastName);

  return (
    <div className="student-avatar" style={{ backgroundColor: color }}>
      <div className="student-avatar-initials">
        {firstName.charAt(0)}
        {lastName.charAt(0)}
      </div>
    </div>
  );
};
